export default "__VITE_ASSET__Bc_aokY2__";